<template>
  <summary-section :heading="heading">
    <template v-slot:actions>
      <router-link
        v-if="link"
        :to="link"
        class="summary-section__action-link"
      >
        View All
      </router-link>
    </template>
    <template>
      <loading-spinner v-if="!activityStream.activities && loading !== 0" />
      <activity-stream
        v-else
        :activity-stream="activityStream"
        :has-scroll-pagination="false"
      />
      <div
        v-if="loading === 0 && !activityStream.activities"
        class="activity-stream-summary__empty"
      >
        No recent activity
      </div>
    </template>
  </summary-section>
</template>

<script>
import SummarySection from '@/components/User/Summary/SummarySection.vue';
import ActivityStream from '@/components/User/Activity/ActivityStream.vue';
import { ACTIVITY_STREAM_QUERY } from '@/graphql/queries/activity-stream-queries';
import { mapGetters } from 'vuex';

export default {
  components: {
    SummarySection,
    ActivityStream,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activityStream: {
        activities: [],
      },
      userId: this.user.id,
      first: 6,
      loading: 0,
    };
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    heading() {
      return this.userId === this.currentUser.id ? 'My Activity' : 'Activity';
    },
  },
  apollo: {
    activityStream: {
      query: ACTIVITY_STREAM_QUERY,
      variables() {
        return {
          first: this.first,
          userId: this.userId,
        };
      },
    },
  },
};
</script>
